import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
    selector: 'mh-core-lib-survey-preview-dropdown',
    templateUrl: './survey-preview-dropdown.component.html',
    styleUrls: ['./survey-preview-dropdown.component.scss'],
    standalone: false
})
export class CoreLibSurveyPreviewDropdownComponent implements OnChanges {
  @Input()
  selectedSurvey: any;

  @Input()
  show = true;

  @Output()
  previewOpened = new EventEmitter<string>();

  test_urls: any[] = [];
  isOpen = false;

  ngOnChanges() {
    this.updateTestUrls();
  }

  updateTestUrls() {
    if (this.selectedSurvey && this.selectedSurvey.survey && this.selectedSurvey.survey[0]) {
      this.test_urls = this.getSurveyLinks(this.selectedSurvey.survey[0]);
    } else {
      this.test_urls = [];
    }
  }

  getSurveyLinks(survey) {
    if (survey.version === 2 && survey.languages) {
      return survey.languages.map((l) => ({
        language_id: l.language.id,
        language_code: l.language.code,
        url: `${window.location.origin}/survey-public/survey/${survey.token}?guest=MQ==&lang=${l.language.code}&skipConfirmation=true`,
      }));
    }
    return [];
  }

  handleOpenPreview(url: string) {
    window.open(url, '_blank');
    this.previewOpened.emit(url);
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  get hasTestUrls() {
    return this.test_urls && this.test_urls.length > 0;
  }

  trackByLanguageId(index: number, item: { language_id: number; language_code: string; url: string }): number {
    return item.language_id;
  }
}
